require('./bootstrap');
require('jscroll');

import {tns} from 'tiny-slider/src/tiny-slider';

window.tns = tns;

$(function () {
    let searchBlock = $('#search-block');

    searchBlock.on('show.bs.collapse', function () {
        updateFiltersPosition($(this).outerHeight());
    });

    searchBlock.on('hide.bs.collapse', function () {
        updateFiltersPosition(-$(this).outerHeight());
    });

    updateFiltersPosition();

    $('#product-added').modal();

    $(window).on('resize', function () {
        executeEqualMeasures();
    });

    executeEqualMeasures();

    $('.toggle-favourite').click(function () {
        const product = $(this).data('product');
        const ut = $(this).data('ut');
        const btn = $(this);
        btn.addClass('animate-favourite');
        $.get({
            url: '/api/toggle-favourites/' + product + '/' + ut
        }).done(function (result) {
            if (result['success']) {
                const icon = btn.find('i');
                icon.toggleClass('las lar');
                btn.attr('title', icon.hasClass('lar') ? btn.data('like') : btn.data('unlike'));

                const favouritesCount = result['favourites_count'];
                const badge = $('.favourite-badge').find('span.badge.badge-over.badge-danger');

                if (favouritesCount > 0) {
                    if (badge.length) {
                        badge.text(favouritesCount)
                    } else {
                        $('.favourite-badge').append('<span class="badge badge-over badge-danger">' + favouritesCount + '</span>');
                    }
                } else {
                    if (badge.length) {
                        badge.remove();
                    }
                }
            }
            setTimeout(function () {
                btn.removeClass('animate-favourite');
                const favouriteBox = btn.closest('.favourite-box');
                if (favouriteBox.length) {
                    $(favouriteBox).fadeOut('normal', function () {
                        $(this).remove();
                    });
                }
            }, 600);
        });
    });

    initializeSliders();
    initializeFilters();
    initializeMobileSubcategories();
    initializeMobileMenus();
    obfuscateContacts();
    initializeScrollingPagination();
});

$(window).on('load', function () {
    executeEqualMeasures();
});

function updateFiltersPosition(extraHeight = 0) {
    let headerNavbarHeight = $('#header-navbar').outerHeight() + extraHeight;
    $('.sticky-top-filters-lt-lg').css('top', headerNavbarHeight + 'px');
}

function executeEqualMeasures() {
    let equalHeightElements = $('[data-equal-height-target]');

    equalHeightElements.each(function () {
        let destinationElement = $(this);
        let targetSelector = destinationElement.data('equal-height-target');
        let targetElement = $(targetSelector)

        if (targetElement.is(':hidden')) {
            destinationElement.height('');
            return;
        }

        destinationElement.height(targetElement.outerHeight());
    });

    let equalWidthElements = $('[data-equal-width-target]');

    equalWidthElements.each(function () {
        let destinationElement = $(this);
        let targetSelector = destinationElement.data('equal-width-target');
        let targetElement = $(targetSelector)

        if (targetElement.is(':hidden')) {
            destinationElement.width('');
            return;
        }

        destinationElement.width(targetElement.outerWidth());
    });
}

function initializeSliders() {
    if ($('#tns-tiles').length) {
        tns({
            container: '#tns-tiles',
            items: 1,
            slideBy: 'page',
            autoplay: false,
            controls: false,
            autoplayButtonOutput: false,
            navContainer: '#tns-tiles-nav',
            navPosition: 'bottom',
            disable: false,
            preventScrollOnTouch: 'auto',
            responsive: {
                768: {
                    disable: true
                }
            }
        });
    }

    if ($('#tns-banner-tiles').length) {
        tns({
            container: '#tns-banner-tiles',
            items: 1,
            slideBy: 'page',
            autoplay: false,
            controls: false,
            autoplayButtonOutput: false,
            navContainer: '#tns-banner-tiles-nav',
            navPosition: 'bottom',
            disable: false,
            preventScrollOnTouch: 'auto',
            responsive: {
                768: {
                    disable: true
                }
            }
        });
    }

    const linksAndImagesSelectors = ['#tns-links-and-images-0', '#tns-links-and-images-1'];
    linksAndImagesSelectors.forEach(function (selector) {
        if ($(selector).length) {
            tns({
                container: selector,
                items: 1,
                slideBy: 1,
                autoplay: true,
                controls: false,
                autoplayButtonOutput: false,
                disable: false,
                navContainer: selector + '-nav',
                navPosition: 'bottom',
                preventScrollOnTouch: 'auto',
                responsive: {
                    992: {
                        disable: true
                    }
                }
            });
        }
    });

    const homeWidgetsProductSlideSelectors = ['#tns-home-products-0-container', '#tns-home-products-1-container', '#tns-home-products-2-container'];
    homeWidgetsProductSlideSelectors.forEach(function (selector) {
        if ($(selector + ' .products').length) {
            const slider = tns({
                container: selector + ' .products',
                items: 1,
                slideBy: 'page',
                autoplay: true,
                controls: false,
                autoplayButtonOutput: false,
                navContainer: selector + ' .tns-products-nav',
                navPosition: 'bottom',
                preventScrollOnTouch: 'auto',
                responsive: {
                    576: {
                        items: 2,
                    },
                    992: {
                        items: 3,
                    },
                    1200: {
                        items: productsPerRow,
                    }
                }
            });

            const updateNav = function () {
                let pages = slider.getInfo().pages;
                Array.from(slider.getInfo().navContainer.children).forEach(function (item, index) {
                    item.style.display = 'block'
                    if (index >= pages) item.style.display = 'none'
                });
            }

            updateNav();

            slider.events.on('newBreakpointStart', updateNav);
        }
    });

    const productSlideSelectors = ['#tns-related-products-container', '#tns-similar-products-container'];
    productSlideSelectors.forEach(function (selector) {
        if ($(selector + ' .products').length) {
            const slider = tns({
                container: selector + ' .products',
                items: 2,
                slideBy: 'page',
                autoplay: true,
                controls: false,
                autoplayButtonOutput: false,
                navContainer: selector + ' .tns-products-nav',
                navPosition: 'bottom',
                preventScrollOnTouch: 'auto',
                responsive: {
                    768: {
                        items: 3,
                    },
                    992: {
                        items: 4,
                    },
                    1200: {
                        items: productsPerRow,
                    }
                }
            });

            const updateNav = function () {
                let pages = slider.getInfo().pages;
                Array.from(slider.getInfo().navContainer.children).forEach(function (item, index) {
                    item.style.display = 'block'
                    if (index >= pages) item.style.display = 'none'
                });
            }

            updateNav();

            slider.events.on('newBreakpointStart', updateNav);
        }
    });

    if ($('#tns-services').length) {
        const slider = tns({
            container: '#tns-services',
            items: 2,
            slideBy: 'page',
            autoplay: true,
            controls: false,
            autoplayButtonOutput: false,
            navContainer: '#tns-services-nav',
            navPosition: 'bottom',
            disable: false,
            preventScrollOnTouch: 'auto',
            responsive: {
                768: {
                    items: 3
                },
                992: {
                    items: productsPerRow
                }
            }
        });

        const updateNav = function () {
            let pages = slider.getInfo().pages;
            Array.from(slider.getInfo().navContainer.children).forEach(function (item, index) {
                item.style.display = 'block'
                if (index >= pages) item.style.display = 'none'
            });
        }

        updateNav();

        slider.events.on('newBreakpointStart', updateNav);
    }

    if ($('#tns-services-2').length) {
        const slider = tns({
            container: '#tns-services-2',
            items: 2,
            slideBy: 'page',
            autoplay: true,
            controls: false,
            autoplayButtonOutput: false,
            navContainer: '#tns-services-nav',
            navPosition: 'bottom',
            disable: false,
            preventScrollOnTouch: 'auto',
            responsive: {
                768: {
                    disable: true
                },
            }
        });

        const updateNav = function () {
            let pages = slider.getInfo().pages;
            Array.from(slider.getInfo().navContainer.children).forEach(function (item, index) {
                item.style.display = 'block'
                if (index >= pages) item.style.display = 'none'
            });
        }

        updateNav();

        slider.events.on('newBreakpointStart', updateNav);
    }
}

function initializeFilters() {
    const mobileFiltersElement = $('#mobile-filters');
    const checkedFilters = mobileFiltersElement.find('input:checkbox:checked').length;

    if (mobileFiltersElement.length) {

        let showResultInputClass = 'btn btn-primary btn-rounded' + (checkedFilters > 0 ? '-left' : '');

        const mobileFilters = new Mmenu('#mobile-filters', {
            navbar: {
                title: 'Филтриране'
            },
            navbars: [
                {
                    content: ['prev', 'title', 'close']
                },
                {
                    position: 'bottom',
                    content: [
                        '<div>' +
                        '<input id="show-results" type="submit" value="Покажи резултатите" class="' + showResultInputClass + '">' +
                        '<button id="filters-reset" class="btn btn-outline-dark">Изчисти</button>' +
                        '</div>'
                    ]
                }
            ],
            extensions: [
                'fullscreen',
                'multiline'
            ]
        }, {
            offCanvas: {
                page: {
                    selector: '#page'
                }
            }
        });

        mobileFiltersElement.removeClass('d-none');

        $('a[href="#mobile-filters"]').click(function (e) {
            e.preventDefault();
            mobileFilters.API.open();
        });

        $('#filters-reset').click(function (e) {
            e.preventDefault();
            $('#show-results').removeClass('btn-rounded-left').addClass('btn-rounded');
            mobileFiltersElement.find('input:checkbox').prop('checked', false);
            mobileFiltersElement.find('input:checkbox').removeAttr('checked');
            updateFilterBadges(mobileFiltersElement);
        });

        mobileFiltersElement.find('input:checkbox').change(function () {
            updateFilterBadges(mobileFiltersElement);
            let numberOfCheckedFilters = mobileFiltersElement.find('input:checkbox:checked').length;

            if (numberOfCheckedFilters > 0) {
                $('#show-results').removeClass('btn-rounded').addClass('btn-rounded-left');
            } else {
                $('#show-results').removeClass('btn-rounded-left').addClass('btn-rounded');
            }
        })

        updateFilterBadges(mobileFiltersElement);
    }
}

function updateFilterBadges(form) {
    let totalCheckedFiltersCount = 0;

    form.find('.mm-panel').each(function () {
        const panelId = this.id;
        const checkedFiltersCount = $(this).find('input:checked').length;
        totalCheckedFiltersCount += checkedFiltersCount;
        form.find('.filter-group a[href="#' + panelId + '"] .badge').html(checkedFiltersCount > 0 ? checkedFiltersCount : '');
    });

    form.find('#filters-reset').toggleClass('d-none', totalCheckedFiltersCount === 0);
}

function initializeMobileSubcategories() {
    const mobileSubcategoriesElement = $('#mobile-subcategories');

    if (mobileSubcategoriesElement.length) {
        const mobileFilters = new Mmenu('#mobile-subcategories', {
            navbar: {
                title: 'Подкатегории'
            },
            navbars: [
                {
                    content: ['prev', 'title', 'close']
                }
            ],
            extensions: [
                'fullscreen',
                'multiline'
            ]
        }, {
            offCanvas: {
                page: {
                    selector: '#page'
                }
            }
        });
        mobileSubcategoriesElement.removeClass('d-none');
    }
}

function initializeMobileMenus() {
    const mainMobileMenu = new Mmenu('#mobile-menu', {
        navbar: {
            title: 'Категории'
        },
        navbars: [
            {
                content: ['prev', 'title', 'close']
            }
        ],
        extensions: [
            'fullscreen',
            'multiline'
        ]
    }, {
        offCanvas: {
            page: {
                selector: '#page'
            }
        }
    });
    $('#mobile-menu').removeClass('d-none');
}

function obfuscateContacts() {
    let emailSelector = "a#email";
    let phoneSelector = "a#phone";

    if ($(emailSelector).length) {
        const emailAddress = atob($(emailSelector).data('encoded-email'));
        $(emailSelector).text(emailAddress).attr('href', 'mailto: ' + emailAddress);
    }

    if ($(phoneSelector).length) {
        const phone = atob($(phoneSelector).data('encoded-phone'));
        const prettyPhone = atob($(phoneSelector).data('encoded-phone-pretty'));
        $(phoneSelector).text(prettyPhone).attr('href', 'tel: ' + phone);
    }
}

function initializeScrollingPagination() {
    let scrollingPagination = $('.scrolling-pagination');
    if (scrollingPagination.length > 0) {
        $('ul.pagination').hide();
        scrollingPagination.jscroll({
            autoTrigger: true,
            padding: 500,
            nextSelector: '.pagination li.current-page + li a',
            contentSelector: 'div.scrolling-pagination',
            loadingHtml: '<div class="d-flex justify-content-center py-2"><div class="spinner-border text-muted" role="status"><span class="sr-only">Loading...</span></div></div>',
            callback: function () {
                $('ul.pagination').remove();
            }
        });
    }

}
